import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import React, { useCallback } from 'react';

import type { IShoppingProduct } from 'v2/interfaces/shopping';

import { BuyerDetails } from './buyerDetails';
import { ChangePaymentMethod } from './changePaymentMethod';
import InvoiceDetails from './invoiceDetails';
import { PaymentHistory } from './paymentHistory';
import RefundActions from './refundActions';
import RefundStatus from './refundStatus';
import useStyle from '../styles';

interface IProps {
  shopping: IShoppingProduct;
  closeQuickView: () => void;
}

const Info = ({ shopping, closeQuickView }: IProps) => {
  const classes = useStyle();

  const handleClickAccessContent = useCallback(() => {
    window.open('https://app.nutror.com');
  }, []);

  const handleClickDownload = useCallback((hash: string | boolean) => {
    window.open('/downloads/' + hash, '_blank');
  }, []);

  return (
    <>
      <div className={classes.quickviewDataBasic}>
        <Grid container spacing={2}>
          <Grid item md={4} sm={12} xs={12}>
            <div className='image' style={{ backgroundImage: `url(${shopping.product.image})` }}></div>
          </Grid>

          <Grid item md={8} sm={12} xs={12}>
            <div className='info'>
              <h2>{shopping.product.title}</h2>

              <div className='producer'>
                Produtor:
                <div className='data'>{shopping.producer.name}</div>
                <div className='data'>{shopping.producer.email}</div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>

      <div className='m24'></div>

      <BuyerDetails shopping={shopping} />

      <div className='m24'></div>

      {!shopping.unlimited_installment && <InvoiceDetails shopping={shopping} />}

      {shopping.unlimited_installment && <PaymentHistory shopping={shopping} />}

      <div className='m8' />

      <Grid container justify='space-around' spacing={1}>
        <>
          {shopping.product.delivery_nutror && (
            <Grid item xs={12}>
              <Button color='primary' onClick={handleClickAccessContent} fullWidth>
                Acessar conteúdo
              </Button>
            </Grid>
          )}
          {shopping.unlimited_installment && (
            <Grid item xs={12}>
              <ChangePaymentMethod shopping={shopping} closeQuickView={closeQuickView} />
            </Grid>
          )}
          <RefundActions shopping={shopping} />
          {shopping.product.download_hash && (
            <Grid item xs={12}>
              <Button color='primary' onClick={() => handleClickDownload(shopping.product.download_hash)} fullWidth>
                Download Materiais
              </Button>
            </Grid>
          )}
        </>
      </Grid>

      <RefundStatus shopping={shopping} />
    </>
  );
};

export default Info;
